"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEspoolConfigurationModel = exports.espoolConfigurationModelUseableDef = void 0;
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const ConfigurationModel_1 = require("./ConfigurationModel");
const echain_shared_modelling_1 = require("@igus/echain-shared-modelling");
exports.espoolConfigurationModelUseableDef = {
    parent: ConfigurationModel_1.configurationModelUseableDef,
    validation: {
        Espool: true,
        SplitPositionX: true,
        Children: (models) => {
            return Boolean(Array.isArray(models) &&
                (models.length === 2 || models.length === 3) &&
                models.every((model) => { var _a; return Boolean(model.Kette) && ((_a = model.ChildRelation) === null || _a === void 0 ? void 0 : _a.Position) in echain_shared_articles_1.EspoolChainPosition; }));
        },
        Kette: false,
    },
};
exports.isEspoolConfigurationModel = echain_shared_modelling_1.UseableUtil.createGuard(exports.espoolConfigurationModelUseableDef);
//# sourceMappingURL=EspoolConfigurationModel.js.map